/* eslint-disable sonarjs/no-duplicate-string */

'use strict';

const modelBody = '.product-quickview-body';
const $modalBackground = $('.modal-background');
const $quickViewModal = $('.product-quickview-modal');
const mainContainerSelector = '.container.search-results';
const ariaHidden = 'aria-hidden';
const tabPane = '.tab-pane.active';
const ariaExpanded = 'aria-expanded';
const secondDiv = '#productDetails';
/**
 * Parse HTML code in Ajax response
 *
 * @param {string} html - Rendered HTML from quickview template
 * @return {QuickViewHtml} - QuickView content components
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * Replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 */
function fillModalElement(selectedValueUrl) {
    $.spinner().start();
    $(modelBody).empty();
    document.body.classList.add('nb-modal-display');
    $modalBackground.css('display', 'block');
    // This is required for desktop quick view
    $quickViewModal.toggleClass('hidden');
    $quickViewModal.find('button.close').attr(ariaExpanded, true);
    // This makes the modal go off the screen on mobile
    if ($quickViewModal.attr('style')) {
        $quickViewModal.removeAttr('style');
    }
    // This only applies to mobile view
    $quickViewModal.css({ '-webkit-transform': 'translateY(16%)' });
    $('.product-quickview-modal button.close').focus();

    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);
            $(modelBody).html(parsedHtml.body);
            $modalBackground.css('display', 'block');
            $.spinner().stop();
            $('.product-quickview-modal #pdpCarousel video').trigger('play');
            $('.product-quickview-modal #pdpCarousel').carousel('cycle');
        },
        error: function (error) {
            window.console.error('Error loading quickview content: ', error);
            $.spinner().stop();
        }
    });
}

/**
 * Handle QuickView click event when clicking the close button
 */
function closeQuickViewModal() {
    $modalBackground.css('display', 'none');
    $quickViewModal.css({ '-webkit-transform': 'translateY(100%)' });
    $quickViewModal.siblings().attr(ariaHidden, false);
    $quickViewModal.closest('.row').siblings().attr(ariaHidden, false);
    $quickViewModal.find('button.close').attr(ariaExpanded, false);
    $quickViewModal.closest(tabPane).siblings().attr(ariaHidden, false);
    $quickViewModal.closest(mainContainerSelector).siblings().attr(ariaHidden, false);
    document.body.classList.remove('nb-modal-display');
    // This is required for desktop quick view
    $quickViewModal.toggleClass('hidden');
    // This makes the modal go off the screen on mobile
    if ($quickViewModal.attr('style')) {
        $quickViewModal.removeAttr('style');
    }
}

$('body').on('show.bs.modal', '#zoommodal', function (e) {
    if ($('.product-quickview-modal').length) {
        return e.preventDefault();
    }
});

module.exports = {
    showQuickview: function () {
        $(document).ready(function () {
            $('body').on('click', '.js-quickview', function (e) {
                e.preventDefault();
                var selectedValueUrl = $(this).data('url');
                var selectedStyle = $(this).closest('.product').attr('data-selected-style');
                var pid = $(this).closest('.product').attr('data-selected-style');
                if (selectedStyle.length > 0 && pid.length > 0) {
                    selectedValueUrl += `&dwvar_${pid}_style=` + selectedStyle;
                }
                $(e.target).trigger('quickview:show');
                fillModalElement(selectedValueUrl);
            });
        });
    },
    closeQuickview: function () {
        // QuickView close button
        $(document).on('click', '.product-quickview-modal button.close', function (e) {
            e.stopPropagation();
            closeQuickViewModal();
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            var quickViewCtn = response.container;
            if ($('.product-quickview').length > 0) {
                quickViewCtn.attr('data-pid', response.data.product.id);
                quickViewCtn.find('.product-id').text(response.data.product.id);
                $('.full-pdp-link').attr('href', response.data.product.selectedProductUrl);
            }

            if ((response.data.preOrderData && response.data.preOrderData.hasPreOrder) || (response.data.backOrderData && response.data.backOrderData.hasBackOrder)) {
                quickViewCtn.find('button.add-to-cart').prop('disabled', true);
                quickViewCtn.find('.preorder-qty-msg').removeClass('d-none');
            }
        });
    },
    hideDialog: function () {
        $('body').on('product:afterAddToCart', function () {
            closeQuickViewModal();
        });
    }
};
